import api from './api';

export const leadsService = {
  list: (params?: Record<string, any>) => api.get('/leads', { params }).then((r) => r.data),
  getById: (id: number) => api.get(`/leads/${id}`).then((r) => r.data),
  getKanban: (productId: number) =>
    api.get('/leads/kanban', { params: { productId } }).then((r) => r.data),
  getFollowUps: (productId?: number) =>
    api.get('/leads/follow-ups', { params: productId ? { productId } : {} }).then((r) => r.data),
  create: (data: any) => api.post('/leads', data).then((r) => r.data),
  update: (id: number, data: any) => api.patch(`/leads/${id}`, data).then((r) => r.data),
  moveStage: (id: number, stageId: number, lossReason?: string) =>
    api.patch(`/leads/${id}/stage`, { stageId, lossReason }).then((r) => r.data),
  delete: (id: number) => api.delete(`/leads/${id}`).then((r) => r.data),
  getNotes: (id: number) => api.get(`/leads/${id}/notes`).then((r) => r.data),
  createNote: (id: number, content: string) =>
    api.post(`/leads/${id}/notes`, { content }).then((r) => r.data),
  getEmailHistory: (id: number) => api.get(`/leads/${id}/email-history`).then((r) => r.data),
};
